import { useMemo } from 'react';
import { ChevronLeft } from '@mui/icons-material';
import { StackProps } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useAdminInvoiceNumberQuery } from '../../../../api/gql';
import { PageHeader } from '../../../../components/PageHeader';

type Props = {
  invoiceId: string;
  transNs?: string;
  keyPrefix?: string;
} & StackProps;

export const AdminInvoicePageHeader = ({
  invoiceId,
  transNs = 'page-admin-task-detail',
  keyPrefix,
  ...rest
}: Props) => {
  const { t } = useTranslation(transNs, { keyPrefix });
  const { data } = useAdminInvoiceNumberQuery({ id: invoiceId });

  const title = useMemo(() => `${t('invoice')} ${data?.adminInvoice.number ?? ''}`, [data?.adminInvoice.number, t]);

  return <PageHeader title={title} backRouteTo={'..'} Icon={ChevronLeft} {...rest} />;
};
